import api from './api';

const authService = {
  /**
   * Register a new user
   */
  register: async (email, password, passwordConfirm) => {
    const response = await api.post('/auth/register/', {
      email,
      password,
      passwordConfirm
    });
    return response;
  },

  /**
   * Login user
   */
  login: async (email, password) => {
    const response = await api.post('/auth/login/', {
      email,
      password
    });
    return response;
  },

  /**
   * Logout user
   */
  logout: async () => {
    const response = await api.post('/auth/logout/', {});
    return response;
  },

  /**
   * Get current logged in user
   */
  getCurrentUser: async () => {
    const response = await api.get('/auth/user/');
    return response;
  }
};

export default authService;
